import { useSelectedAudioNoteId } from '@renderer/stores/side-panel'
import { useQuery } from '@tanstack/react-query'
import AudioNoteIpcRenderer from '@renderer/ipc/AudioNoteIpc.renderer'
import { AudioNote } from '@highlight/common'
import { useSharedWithMe } from '@renderer/windows/features/memory/hooks/queries-shared'

export const useSelectedAudioNote = () => {
  const selectedAudioNoteId = useSelectedAudioNoteId()
  const { data: sharedItems } = useSharedWithMe()

  return useQuery({
    queryKey: ['audio-note', selectedAudioNoteId],
    queryFn: async () => {
      if (!selectedAudioNoteId) return null

      const sharedItem = sharedItems?.find((item) => item.id === selectedAudioNoteId)
      if (sharedItem) {
        return sharedItem as AudioNote
      }

      const result = await AudioNoteIpcRenderer.getAudioNote(selectedAudioNoteId)
      return result as AudioNote
    },
    enabled: !!selectedAudioNoteId,
  })
}
